import React from "react";
import { Link } from "react-router-dom";

export function UserCourses({
  id,
  title,
  isActive,
  finished,
  percAvan,
  percCal,
}) {
  const progress = finished
    ? 100
    : Math.min(
        100,
        Math.max(0, Number(percAvan) || 0)
      );

  const grade = Math.min(
    100,
    Math.max(0, Number(percCal) || 0)
  );

  return (
    <article
      className={`modern-course-card anim ${
        !isActive ? "modern-course-card-disabled" : ""
      }`}
      style={{ "--delay": ".3s" }}
    >

      <div className="modern-course-card-top">

        <div className="modern-course-icon">
          <i className="fas fa-graduation-cap" />
        </div>

        <div
          className={`modern-course-status ${
            finished
              ? "completed"
              : isActive
              ? "active"
              : "blocked"
          }`}
        >
          <span />

          {finished
            ? "Completado"
            : isActive
            ? "Activo"
            : "Bloqueado"}
        </div>

      </div>

      <div className="modern-course-card-body">

        <span className="modern-course-label">
          CURSO
        </span>

        <h3>{title}</h3>

        <div className="modern-course-progress-header">

          <span>Progreso</span>

          <strong>
            {Math.round(progress)}%
          </strong>

        </div>

        <div className="modern-course-progress">

          <div
            className="modern-course-progress-bar"
            style={{
              width: `${progress}%`,
            }}
          />

        </div>

        <div className="modern-course-metrics">

          <div>
            <span>Avance</span>
            <strong>{Math.round(progress)}%</strong>
          </div>

          <div>
            <span>Calificación</span>
            <strong>
              {grade > 0
                ? `${Math.round(grade)}%`
                : "—"}
            </strong>
          </div>

        </div>

      </div>

      <div className="modern-course-card-footer">

        {isActive ? (
          <Link
            to={`/course/${id}`}
            className="modern-course-button"
          >
            <span>
              {finished
                ? "Ver curso"
                : progress > 0
                ? "Continuar curso"
                : "Comenzar curso"}
            </span>

            <i className="fas fa-arrow-right" />
          </Link>
        ) : (
          <div className="modern-course-button disabled">
            <span>Curso bloqueado</span>
            <i className="fas fa-lock" />
          </div>
        )}

      </div>

    </article>
  );
}